module.exports = "mutation DeleteHomepageTab($data:DeleteHomepageTabInput!){deleteHomepageTab(data:$data){success}}"